import { render, staticRenderFns } from "./consultas-publico.vue?vue&type=template&id=9845257e&scoped=true"
import script from "./consultas-publico.vue?vue&type=script&lang=js"
export * from "./consultas-publico.vue?vue&type=script&lang=js"
import style0 from "./consultas-publico.vue?vue&type=style&index=0&id=9845257e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9845257e",
  null
  
)

export default component.exports